import React, { Component } from 'react'
import tool from '../../utils/tool';
import $ from 'jquery';
import API from './../../config/api';
import Header from "../../components/Header/header";
import NotFound from '../../components/NotFound'
import './index.scss'
// 新京号话题
export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      desc:'', // 描述
      cover:'', //封面图
      topicTitle:'', //标题
      descType:false, // 导语收起展开状态
      articleList:[], //话题文章列表
      xjhList:[], //新京号列表
      name:'topic',
      uuid:'',
      infoData:{},
      topicArticleData:{},
      notFound:false
    }
  }

  componentWillMount() {
    
  }

  componentDidMount = () => {
    const search = this.props.location.search;
    const params = tool.getParams(search) || {};
    const topic_uuid = params.topic_uuid;
    this.setState({
      uuid:topic_uuid
    },() => {
      this.statistics();
    })
    this.getXjhList() //获取新京号列表
    this.getTopicDetail(topic_uuid) // 获取话题详情
    this.getTopicArticleList(topic_uuid) //获取话题文章列表
    if(this.state.infoData === '{}' && this.state.topicArticleData === '{}' ){
      this.setState({
        notFound:true
      })
    }
    
  };

  componentWillReceiveProps = () =>{
    const search = this.props.location.search;
    const params = tool.getParams(search) || {};
    const topic_uuid = params.topic_uuid;
    this.setState({
      uuid:topic_uuid
    })
    this.getXjhList() //获取新京号列表
    this.getTopicDetail(topic_uuid) // 获取话题详情
    this.getTopicArticleList(topic_uuid) //获取话题文章列表
    if(this.state.infoData === '{}' && this.state.topicArticleData === '{}' ){
      this.setState({
        notFound:true
      })
    }
  }


  // 设置导语收起与展开
  setDesc = (type) => {
		if (type === 1) {
			this.setState({descType: true})
		} else if (type === 2) {
			this.setState({descType: false})
		}
  }

  // 获取话题详情
  getTopicDetail = (topic_uuid) => {
    $.ajax({
      type: 'get',
      url: API.xjh_topic_info,
      async: false,
      headers: {
        version: 'v104'
      },
      data: {
        topic_uuid: topic_uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if(res.code === 0){
        this.setState({
          infoData:JSON.stringify(res.data),
          cover:res.data.cover,
          topicTitle:res.data.title,
          desc:res.data.describe
        })
      } else {
        this.setState({
          notFound:true
        })
      }
    }).fail(() => {
      this.setState({
        notFound:true
      })
    });
  }
  // 获取话题文章列表
  getTopicArticleList = (topic_uuid) => {
    $.ajax({
      type: 'get',
      url: API.xjh_topic_articleList,
      async: false,
      headers: {
        version: 'v104'
      },
      data: {
        topic_uuid: topic_uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if(res.code === 0){
        this.setState({
          topicArticleData:JSON.stringify(res.data),
          articleList:res.data
        })
      } else {
        this.setState({
          notFound:true
        })
      }
    })
  }

  // 获取新京号列表
  getXjhList = () => {
    $.ajax({
      type: 'get',
      url: API.xjh_list,
      async: false,
      headers: {
        version: 'v104'
      },
      data: {},
      dataType: 'json'
    }).done((res) => {
      if(res.code === 0){
        this.setState({
          xjhList:res.data
        })
      }
    });
  }

  // 点击稿件
  goDetail(item) {
		switch (parseInt(item.type)) {
			case 1:     //图文
				this.props.history.push('/detail/1/' + item.uuid)
				break;
			case 2:     //视频
				this.props.history.push('/detail/2/' + item.uuid + '/2')
				break;
			case 3:
			  if(item.row.special_type/1 ===1){
          this.props.history.push('/subject/1/' + item.uuid)
        }else if(item.row.special_type/1 ===2){
          this.props.history.push('/subject/2/' + item.uuid)
        }else if(item.row.special_type/1 ===3){
          this.props.history.push('/newSubject/' + item.uuid)
        }
				break;
			case 4:     //图说
				this.props.history.push('/detail/3/' + item.uuid)
				break;
			case 6:     //直播
				this.props.history.push('/detail/2/' + item.uuid + '/6')
				break;
      case 50:
        window.location.href = item.row.ext_data.article_url
        break;
      default:''
		}
  }

  // 分享
  statistics(share) {
    var op = share ? 'share' : 'pv';
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = API.pv + '?xm=bjnews&wz=topic&op=' + op + '&pt=wap&unique_id=' + this.state.uuid;     //填自己的js路径
    $('body').append(script);
  }
  
  render() {
    const {desc,descType,cover,topicTitle,articleList,name,uuid} = this.state
    return (
      <div className='topic'>
        {this.state.notFound?<NotFound />:
          <div>
            {/*头部*/}
            <Header name={name} uuid={uuid}/>
            {/* 头部图片 */}
              <div className='header'>
                <img src={cover} alt="头部图片"/>
                <div className='shadow'>{topicTitle}</div>
              </div>
            {/*描述*/}
            {desc?
              <div className="topic_desc">
              {desc.length >= 64 && !descType ? desc.substring(0, 63) : desc}
              {desc.length >= 64 && !descType ?
                <span onClick={this.setDesc.bind(this, 1)} className="descBtn">
                  <span className="descIcon"></span>
                  展开</span> :
                desc.length >= 64 ?
                <p onClick={this.setDesc.bind(this, 2)} className="descBtn">收起</p> : ''
              }
            </div>:''
            }
            {/* 下方列表 */}
            <div className='content_list'>
              {articleList.map((item,index) => {
                return (
                  <div className='list_item' onClick={this.goDetail.bind(this,item)} key={index}>
                    <div className='leftPic'>
                      <img src={item.row.cover} alt=""/>
                    </div>
                    <div className='rightContent'>
                    {/* -webkit-box-orient: vertical;这个属性jsx解析不出来 */}
                      <p className='item_title limit-line2' style={{"WebkitBoxOrient": "vertical"}}>
                        {item.row.title}
                      </p>
                      <p><span style={{marginRight:'20px'}}>{item.row.xjh_info[0].institution_name}</span><span>{tool.dateStr(item.row.publish_timestamp)}</span></p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        }
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Topic/index.js